import InputTypes from '../../../core/enums/InputTypes';

const inputsSolicitacoes = [
    {
        name: 'id',
        label: 'Nº',
        type: InputTypes.INTEGER,
        table: { use: true },
    },
    {
        name: 'orgao',
        label: 'Órgão/Entidade',
        type: InputTypes.ENTITY,
        table: { use: true, nameUse: 'indicador.orgao.descOrgao' },
        export: { use: true, nameUse: 'indicador.orgao.descOrgao' },
        filter: { use: true, nameUse: 'indicador.orgao.idenOrgao' },
    },
    {
        name: 'codigoIndicador',
        label: 'Código do Indicador',
        type: InputTypes.INTEGER,
        filter: { use: true, nameUse: 'indicador.codgIndicador' },
        table: { use: true, nameUse: 'indicador.codgIndicador' },
        export: { use: true, nameUse: 'indicador.codgIndicador' },
    },
    {
        name: 'nomeIndicador',
        label: 'Nome do Indicador',
        type: InputTypes.STRING,
        filter: { use: true, nameUse: 'indicador.nmIndicador' },
        table: { use: true, nameUse: 'indicador.nmIndicador' },
        export: { use: true, nameUse: 'indicador.nmIndicador' },
    },
    {
        name: 'contaAcessoCadastro',
        label: 'Usuário de Solicitação',
        type: InputTypes.ENTITY,
        filter: { use: true, nameUse: 'contaAcessoCadastro.nome', useLike: true },
        table: { use: true, nameUse: 'contaAcessoCadastro.nome' },
    },
    {
        name: 'dataCadastro',
        label: 'Data',
        type: InputTypes.DATE,
        table: { use: true },
    },
    {
        name: 'tipoSolicitacaoAtivacao',
        label: 'Tipo',
        type: InputTypes.ENTITY,
        filter: { use: true, nameUse: 'tipoSolicitacaoAtivacao.id' },
        table: { use: true, nameUse: 'tipoSolicitacaoAtivacao.descTipoSolicitacaoAtivacao' },
        export: { use: true, nameUse: 'tipoSolicitacaoAtivacao.descTipoSolicitacaoAtivacao' },
    },
    {
        name: 'situacao',
        label: 'Situação',
        type: InputTypes.ENTITY,
        filter: {
            use: true,
            nameUse: 'situacaoSolicitacaoAtivacao.codgSituacaoSolicitacaoAtivacao',
        },
        table: {
            use: true,
            nameUse: 'situacaoSolicitacaoAtivacao.descSituacaoSolicitacaoAtivacao',
        },
        export: {
            use: true,
            nameUse: 'situacaoSolicitacaoAtivacao.descSituacaoSolicitacaoAtivacao',
        },
    },
    {
        name: 'responsavelAnalise',
        label: 'Analista Negocial',
        type: InputTypes.ENTITY,
        filter: { use: true, nameUse: 'responsavelAnalise.idenPessoa' },
        table: { use: true, nameUse: 'responsavelAnalise.nomePessoa' },
        export: { use: true, nameUse: 'responsavelAnalise.nomePessoa' },
    },
    {
        name: 'dataValidacao',
        label: 'Data de Validação',
        type: InputTypes.DATE,
        table: { use: true, nameUse: 'dataAtualizacao' },
    },
    {
        name: 'flagValidacao',
        label: 'Validado',
        type: InputTypes.BOOLEAN,
        form: { use: true, validate: { required: true } },
    },
    {
        name: 'manifestacao',
        label: 'Manifestação Técnica',
        type: InputTypes.STRING,
        form: { use: true, validate: { required: true } },
    },
];

export { inputsSolicitacoes };
